import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-plams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-plams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CreateApplicationLocationPlamsConstants } from "./create-application-location-plams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapService } from "../../../../map/shared/map.service";
import { MapTools } from "../../../../map/shared/map.tools";
import GeometryUtils from "../../../../shared/utils/geometry-utils";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { CreateApplicationLocationEcConstants } from "../../ec/create-application-location-ec/create-application-location-ec.constants";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
let CreateApplicationLocationPlamsComponent = class CreateApplicationLocationPlamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    mapTools;
    requestStatusService;
    changeDetectorRefs;
    searchApplicationsService;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationPlamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationPlamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationPlamsConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationPlamsConstants.DESCRIPTION_LABEL_4;
    descriptionLabel5 = CreateApplicationLocationPlamsConstants.DESCRIPTION_LABEL_5;
    applicationControl = CreateApplicationLocationPlamsConstants.APPLICATION_TYPE_CONTROL;
    validationMessages = CreateApplicationLocationPlamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationPlamsConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationPlamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationPlamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationPlamsConstants.FARM_NO_CONTROL;
    zoningControl = CreateApplicationLocationPlamsConstants.ZONING_CONTROL;
    streetNumberControl = CreateApplicationLocationPlamsConstants.STREET_NO_CONTROL;
    streetNameControl = CreateApplicationLocationPlamsConstants.STREET_NAME_CONTROL;
    townControl = CreateApplicationLocationPlamsConstants.TOWN_CONTROL;
    sgCodeControl = CreateApplicationLocationPlamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationPlamsConstants.ADDRESS_CONTROL;
    ownerControl = CreateApplicationLocationPlamsConstants.OWNER_CONTROL;
    applicationSelectLabel = CreateApplicationLocationPlamsConstants.APPLICATION_TYPE_PLACEHOLDER;
    dropdownApplicationPlaceholder = CreateApplicationLocationPlamsConstants.APPLICATION_TYPE_PLACEHOLDER;
    erfNoTextPlaceHolder = CreateApplicationLocationPlamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationPlamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationPlamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationPlamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    zoningControlTextPlaceHolder = CreateApplicationLocationPlamsConstants.ZONING_TEXT_PLACEHOLDER;
    streetNumberTextPlaceHolder = CreateApplicationLocationPlamsConstants.STREET_NO_TEXT_PLACEHOLDER;
    streetNameTextPlaceHolder = CreateApplicationLocationPlamsConstants.STREET_NAME_TEXT_PLACEHOLDER;
    townTextPlaceHolder = CreateApplicationLocationPlamsConstants.TOWN_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationPlamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationPlamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    drawPolyonLabel = CreateApplicationLocationPlamsConstants.DRAW_POLYGON_LABEL;
    polygonDrawnLabel = CreateApplicationLocationPlamsConstants.POLYGON_DRAWN_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = CreateApplicationLocationPlamsConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = CreateApplicationLocationPlamsConstants.OWNER_LABEL;
    copyOwnerLabel = CreateApplicationLocationPlamsConstants.COPY_OWNER_LABEL;
    layerReference = CreateApplicationLocationPlamsConstants.LAYER_REF;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerShowGroupsDropdown = true;
    ownerListLabel = "Owner";
    appTypes = [];
    applicants;
    leaseAreaDrawn = false;
    fullApplicationCheckRequired = true;
    showOnlyPropertyAndZoningLayers = false;
    existingApplication = false;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    applicantGroups = [];
    mapComponent;
    isMapLoaded = false;
    sketch;
    leaseGraphic = null;
    hasLoadedLookups = false;
    hasLoadedApplicationProperties = false;
    hasSavedLeaseArea = false;
    selectedApplicationType = null;
    selectedPropertySubscription;
    selectedApplicationDetailsRcSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, mapTools, requestStatusService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
        this.initForm();
    }
    ngOnInit() {
        this.hasLoadedApplicationProperties = false;
        this.hasSavedLeaseArea = false;
        this.applicationCreateService.setHasLoadedLookups(false);
        this.selectedApplicationService.$applicationSavedSubject.next(false);
        if (this.aflaModuleStrategyService.lookups.has("appTypes")) {
            this.appTypes = this.aflaModuleStrategyService.lookups.get("appTypes");
            this.applicationCreateService.setHasLoadedLookups(true);
        }
        else {
            this.getLookups();
        }
        this.getMetadata();
        this.subscribeToProperty();
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
        this.applicationCreateService.hasLoadedLookupsAsObservable.subscribe((hasLoadedLookups) => {
            this.hasLoadedLookups = hasLoadedLookups;
            if (this.hasLoadedLookups) {
                this.onGetSelectedApplication();
            }
        });
        if (this.applicationCreateService.propertyData) {
            this.loadExistingProperty(this.applicationCreateService.propertyData);
            this.applicationCreateService.propertyData = null;
        }
        this.mapService.$removeAllMapToolGraphics.subscribe((res) => {
            this.mapToolGraphicsRemoved();
        });
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapToolGraphicsRemoved() {
        this.leaseGraphic = null;
        this.propertiesForm.get("leaseArea").setValue(null);
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.sketch.on("create", (event) => {
            if (event.state === "start") {
                this.mapService.showPopups = false;
            }
            if (event.state === "complete") {
                this.mapService.showPopups = true;
                if (this.selectedApplicationType === "Lease") {
                    if (event.graphic.geometry.type === "polygon") {
                        this.leaseGraphic = event.graphic;
                        // get the geometries of the properties in the properties layer
                        const geometries = [];
                        let propertyGeom;
                        this.getProperties().controls.forEach(item => {
                            const geom = item.get("geometry").value;
                            if (geom !== null) {
                                geometries.push(geom);
                            }
                        });
                        // If properties have been selected ... check the lease area drawn is within those properties
                        if (geometries.length > 0) {
                            if (geometries.length > 1) {
                                propertyGeom = geometryEngine.union(geometries);
                            }
                            else {
                                propertyGeom = geometries[0];
                            }
                            if (geometryEngine.within(this.leaseGraphic.geometry, propertyGeom)) {
                                this.propertiesForm.get("leaseArea").setValue(event.graphic.geometry);
                            }
                            else {
                                this.mapTools.sketchGraphicsLayer.removeAll();
                                this.appController.showMessage(CreateApplicationLocationPlamsConstants.LEASE_AREA_OUTSIDE_SELECTED_PROPERTY_MESSAGE, AlertType.Warning);
                            }
                        }
                        else {
                            // no property selected
                            this.propertiesForm.get("leaseArea").setValue = null;
                            this.mapTools.sketchGraphicsLayer.removeAll();
                            this.mapService.showPopups = true;
                            this.appController.showMessage(CreateApplicationLocationPlamsConstants.NO_PROPERTIES_SELECTED_MESSAGE, AlertType.Warning);
                        }
                    }
                    else {
                        this.appController.showMessage(CreateApplicationLocationPlamsConstants.LEASE_AREA_EXISTS_MESSAGE, AlertType.Warning);
                    }
                }
            }
            else if (event.state === "cancel") {
                this.mapService.showPopups = true;
            }
            else {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
            if (this.propertiesForm.get("leaseArea").value !== null) {
                this.mapTools.sketchGraphicsLayer.removeAll();
                this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.propertiesForm.get("leaseArea").value)], "Draw Tool Layer", true);
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
        this.propertiesForm.get(this.applicationControl).enable();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        this.changeDetectorRefs.detectChanges();
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    updateRequiredFields() {
        this.getProperties().controls.forEach(item => {
            const propertyControl = item;
            const erfNoControl = propertyControl.get(this.erfNoControl);
            const farmNoControl = propertyControl.get(this.farmNoControl);
            const subdivisionControl = propertyControl.get(this.subdivisionControl);
            if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.clearValidators();
                subdivisionControl.clearValidators();
                farmNoControl.setValue("");
                subdivisionControl.setValue("");
                farmNoControl.disable();
                subdivisionControl.disable();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = false;
                this.farmNoControlRequired = false;
                this.erfNoControlRequired = true;
            }
            else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.clearValidators();
                erfNoControl.setValue("");
                erfNoControl.disable();
                erfNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = false;
            }
            else {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.enable();
                farmNoControl.enable();
                subdivisionControl.enable();
                erfNoControl.markAsUntouched();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = true;
            }
            const sgCodeControl = propertyControl.get(this.sgCodeControl);
            if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
                sgCodeControl.disable();
            }
            else {
                sgCodeControl.enable();
            }
            erfNoControl.updateValueAndValidity();
            farmNoControl.updateValueAndValidity();
            subdivisionControl.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        });
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        const previousActiveIndex = this.active;
        const numProps = this.getProperties().value.length;
        this.getProperties().removeAt(propertyIndex);
        if (this.propertiesForm.get("leaseArea").value) {
            this.propertiesForm.get("leaseArea").setValue(null);
        }
        // /this.propertiesForm.get("leaseArea").setValue(null);
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries();
        if (previousActiveIndex === propertyIndex && propertyIndex > 0) {
            this.active = propertyIndex - 1;
        }
        else if (previousActiveIndex > propertyIndex) {
            this.active = previousActiveIndex - 1;
        }
        if (numProps > 1) {
            propertyIndex + 1 === numProps ? this.active = propertyIndex - 1 : this.active = propertyIndex;
        }
        this.changeDetectorRefs.detectChanges();
    }
    onCopyOwnerToApplicant(propertyIndex) {
        const ownersControl = this.getProperties().controls[propertyIndex].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
        this.propertiesForm.enable();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and name eq 'ApplicationType'`,
        };
        this.applicationCreateService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(CreateApplicationLocationPlamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const appTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    appTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("appTypes", appTypes);
        this.appTypes = appTypes;
        this.applicationCreateService.setHasLoadedLookups(true);
        this.changeDetectorRefs.detectChanges();
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyData");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationPlamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyData");
            }
        });
        this.updateRequiredFields();
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno")),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum")),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno")),
                zoning: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Zoning", "zoning"), [Validators.required]),
                streetNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetNumber", "streetnumber"), [Validators.required]),
                streetName: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetName", "streetname"), [Validators.required]),
                town: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Town", "town"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null)
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    const propertyControl = this.getProperties();
                    const propertyIndex = propertyControl.length;
                    propertyControl.push(newProperty);
                    this.active = propertyControl.length - 1;
                    this.updateRequiredFields();
                    this.changeDetectorRefs.detectChanges();
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                }, error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationPlamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    onGetSelectedApplication() {
        if (this.hasLoadedLookups && +this.jobId > 0 && this.selectedApplication && !this.hasLoadedApplicationProperties) {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.selectedApplicationType = this.selectedApplication.applicationType;
            this.appTypes.forEach(item => {
                if (item.value === this.selectedApplication.applicationType) {
                    this.propertiesForm.get(this.applicationControl).setValue(item);
                }
            });
            this.propertiesForm.get(this.applicationControl).disable();
            if (this.selectedApplication.leaseAreas && this.selectedApplication.leaseAreas.length > 0) {
                this.hasSavedLeaseArea = true;
                this.propertiesForm.get("leaseAreaId").setValue(this.selectedApplication.leaseAreas[0].id);
            }
            let index = 0;
            this.selectedApplication.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    id: new FormControl(property.id),
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber),
                    subdivision: new FormControl(property.subdivision),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber),
                    zoning: new FormControl(property.zoning, [Validators.required]),
                    streetNumber: new FormControl(property.streetNumber, [Validators.required]),
                    streetName: new FormControl(property.streetName, [Validators.required]),
                    town: new FormControl(property.town, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    owners: new FormControl(property.owners)
                });
                // if property is loaded from an existing application mark for as touched it as touched
                this.propertiesForm.markAllAsTouched();
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.getTrueCentroidSubscription = this.applicationCreateService.getTrueCentroid(url, formData)
                    .subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields();
                        this.changeDetectorRefs.detectChanges();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationPlamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                index++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    applicationTypeChanged() {
        this.selectedApplicationType = this.propertiesForm.get(this.applicationControl).value.value;
        if (this.selectedApplicationType !== null && this.selectedApplicationType === "Lease") {
            this.mapTools.expandWidget("drawTool");
            this.sketch.create("polygon");
        }
        else {
            this.mapTools.collapseWidget("drawTool");
            this.sketch.cancel();
            this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
            if (this.propertiesForm.get("leaseArea").value) {
                this.propertiesForm.get("leaseArea").setValue(null);
            }
        }
        this.updateRequiredFields();
        this.changeDetectorRefs.detectChanges();
    }
    syncMapGeometries() {
        const geometries = [];
        if (this.propertiesForm.get("leaseArea").value) {
            this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.propertiesForm.get("leaseArea").value)], "Draw Tool Layer");
        }
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap(this.layerReference);
        }
        this.changeDetectorRefs.detectChanges();
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    subscribeToClearGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getProperties().clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    if (this.propertiesForm.get("leaseArea").value !== null) {
                        this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
                        this.propertiesForm.get("leaseArea").setValue(null);
                    }
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDetailsRcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = application ? application : null;
            if (this.selectedApplication) {
                this.applicants = this.selectedApplication.applicant;
                this.onGetSelectedApplication();
                CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                if (this.selectedApplication.leaseAreas && this.selectedApplication.leaseAreas.length > 0) {
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.selectedApplication.leaseAreas[0].shape, 102100);
                    const leaseGeom = JsonUtils.fromJSON(geometryArc);
                    this.propertiesForm.get("leaseArea").setValue(leaseGeom);
                    this.propertiesForm.get("leaseAreaId").setValue(this.selectedApplication.leaseAreas[0].id);
                    this.hasSavedLeaseArea = true;
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: MapTools },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationPlamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-plams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateApplicationLocationPlamsComponent);
export { CreateApplicationLocationPlamsComponent };
